
import * as React from "react";
import styled from "styled-components";
import SectionHeader from "../utils/sectionHeader";

function Features() {
  return (
    <FeaturesContainer>
      <SectionHeader 
        title="benefits"
        subtitle="Empowering Institutions with AI-Driven Solutions"
      />
      <FeaturesGrid>
        <TopRow>
          <RapidDeploymentCard>
            <CardHeader>
              <CardIcon role="img" aria-label="Icon" src="https://api.builder.io/api/v1/image/assets/TEMP/8eda4bb001c6ba13f955cd8667b2e9934763b0c4?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc" />
              <CardTitle>Rapid Deployment</CardTitle>
            </CardHeader>
            <CardDescription>
              Rapid deployment in under a week by utilizing existing
              institutional web content, minimizing IT involvement, resulting in
              shorter setup time
            </CardDescription>
          </RapidDeploymentCard>
          <StudentEngagementCard>
            <CardHeaderLight>
              <CardIcon role="img" aria-label="Icon" src="https://api.builder.io/api/v1/image/assets/TEMP/95c43151bdae3515555c310e1e9392b1e43a4c56?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc" />
              <CardTitleDark>Student-Centric Engagement</CardTitleDark>
            </CardHeaderLight>
            <CardDescriptionDark>
              With a student-centric, multi-channel design, supporting both web
              and SMS outreach, students are engaged where they are, in ways
              they prefer
              
            </CardDescriptionDark>
          </StudentEngagementCard>
        </TopRow>
        <BottomRow>
          <PricingCard>
            <CardHeaderLight>
              <CardIcon role="img" aria-label="Icon" src="https://api.builder.io/api/v1/image/assets/TEMP/0a2be5731f0148582c5e431c5fb4f1183b87d66c?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc" />
              <CardTitleDark>Affordable, mid-tier pricing model</CardTitleDark>
            </CardHeaderLight>
            <CardDescriptionDark>
              Affordable, mid-tier pricing model fills the gap between DIY tools
              and expensive enterprise offerings, providing strong ROI with
              transparent installation and monthly SaaS fees
            </CardDescriptionDark>
          </PricingCard>
          <IntegrationCard>
            <CardHeaderLight>
              <CardIcon role="img" aria-label="Icon" src="https://api.builder.io/api/v1/image/assets/TEMP/3ea69f5f7b0a2a0c7932f549fa1b5675c83b2c83?placeholderIfAbsent=true&apiKey=2d7c5855cb2f42a1b4e6163799d67ecc" />
              <CardTitleDark>Secure & Flexible Integration</CardTitleDark>
            </CardHeaderLight>
            <CardDescriptionDark>
              Flexible data privacy and integration options are part of the
              offering, including on-site hosting and compliance-focused
              configurations, making Campus Insights ideal for institutions with
              stringent data security requirements.
            </CardDescriptionDark>
          </IntegrationCard>
        </BottomRow>
      </FeaturesGrid>
    </FeaturesContainer>
  );
}

const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; /* Center children horizontally */
  justify-content: center; /* Optional: vertically center if parent has height */
  max-width: 920px;
  margin: 0 auto; /* Center container itself */
  font-family: Inter;
  padding: 50px;
  overflow-x: hidden;  
  
  @media (max-width: 1291px) {
      padding: 50px 16px;
  }
`;


const HeaderContainer = styled.div`
  align-self: center;
  width: 691px;
  max-width: 100%;
  font-weight: 700;
  text-align: center;
`;

const SectionTitle = styled.header`
  margin: 0;
  color: #1c1b1f;
  font-size: 16px;
  line-height: 1.2;
  letter-spacing: 2px;
  text-transform: uppercase;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const SubtitleContainer = styled.div`
  display: flex;
  margin-top: 20px;
  width: 100%;
  flex-direction: column;
  align-items: center;
  font-size: 48px;
  color: #0a0911;
  letter-spacing: -0.48px;
  line-height: 58px;
  justify-content: start;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 54px;
  }
`;

const MainHeading = styled.p`
  margin: 0;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 54px;
  }
  @media (max-width: 640px) {
    font-size: 28px;
    line-height: 1.2;
  }
`;

const FeaturesGrid = styled.div`
  margin-top: 60px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
`;

const TopRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 20px;
  justify-content: start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const RapidDeploymentCard = styled.div`
  border-radius: 16px;
  background-color: rgba(106, 76, 147, 1);
  color: white;
  align-self: stretch;
  display: flex;
  min-width: 240px;
  max-height: 280px;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  flex-grow: 1;
  flex-shrink: 1;
  width: 360px;
  padding: 24px 24px 38px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 14px 24px 10px;
  }
`;

const CardHeader = styled.div`
  align-self: center;
  display: flex;
  width: 312px;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.2px;
  line-height: 1.4;
  justify-content: start;

  @media(max-width: 640px) {
  font-size: 18px;
    flex-direction: row;
    align-self: flex-start;
  }
`;

const CardIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 64px;
  border-radius: 0px 0px 0px 0px;
  height: 64px;
  @media (max-width: 991px) {
    width: 59px;
    height: 59px;
  }
  @media(max-width: 640px) {
    width: 50px;
    height: 50px;
  }
`;

const CardTitle = styled.p`
  margin: 0;
  margin-top: 16px;
  @media(max-width: 601px) {
  margin-top: 0px;
  margin-left: 10px;
  text-align: left;
  }
`;

const CardDescription = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.08px;
  margin-top: 16px;

  @media (max-width: 991px) {
    display: none;
  }
`;

const StudentEngagementCard = styled.div`
  border-radius: 16px;
  background-color: rgba(235, 216, 255, 1);
  align-self: stretch;
  display: flex;
  min-width: 240px;
  max-height: 280px;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  flex-grow: 1;
  flex-shrink: 1;
  width: 360px;
  padding: 24px 24px 38px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 14px 24px 10px;
  }
`;

const CardHeaderLight = styled.div`
  align-self: center;
  display: flex;
  width: 100%;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  color: #1c1b1f;
  font-weight: 600;
  letter-spacing: -0.2px;
  line-height: 1.4;
  justify-content: start;

  @media(max-width: 640px) {
    font-size: 17px;
    flex-direction: row;
  }
`;

const CardTitleDark = styled.div`
  margin-top: 16px;
  text-align: center;
  
  @media(max-width: 601px) {
  margin-top: 0px;
  margin-left: 10px;
  text-align: left;
  }
`;

const CardDescriptionDark = styled.div`
  color: #3b3a44;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: -0.08px;
  margin-top: 16px;
  
  @media (max-width: 991px) {
    display: none;
  }
`;

const BottomRow = styled.div`
  display: flex;
  margin-top: 20px;
  width: 100%;
  align-items: center;
  gap: 20px;
  justify-content: start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const PricingCard = styled.div`
  border-radius: 16px;
  background-color: rgba(255, 230, 230, 1);
  align-self: stretch;
  display: flex;
  min-width: 240px;
  max-height: 280px;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  flex-grow: 1;
  flex-shrink: 1;
  width: 360px;
  padding: 24px 24px 38px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 14px 24px 10px;
  }
`;

const IntegrationCard = styled.div`
  border-radius: 16px;
  background-color: rgba(221, 239, 255, 1);
  align-self: stretch;
  display: flex;
  min-width: 240px;
  max-height: 280px;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  flex-grow: 1;
  flex-shrink: 1;
  width: 360px;
  padding: 24px 24px 38px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 14px 24px 10px;
  }
`;

export default Features;
